'use client'
import Image from 'next/image'
import SedomBrand from '/public/assets/images/brand/sedom.svg'
import { BackButton } from '@sedomicilier/material-sd'
import useWindowDimensions from '@/app/hooks/UseWindowDimensions'
import { TailwindConfig } from '@sedomicilier/material-sd'
import { useDispatch } from '@/hooks/redux'
import { previousPage } from '@/reducers/workflow'
import { useTranslations } from 'next-intl'
import { useQuery } from '@apollo/client'
import {
  CountryConfigDataType,
  GET_COUNTRY_CONFIG
} from '@/graphql/queries/countryConfig'
import { useSelector } from '@/hooks/redux'

const NavBarBrand = () => {
  const t = useTranslations('common')
  const { width } = useWindowDimensions()
  const dispatch = useDispatch()
  const { path, flow } = useSelector((state) => state.workflow)

  const { data } = useQuery<CountryConfigDataType>(GET_COUNTRY_CONFIG)

  const countryCode = data?.countryConfig.countryCode
  const homeLink =
    countryCode === 'BE'
      ? process.env.NEXT_PUBLIC_HOME_BE
      : process.env.NEXT_PUBLIC_HOME_FR

  return (
    <div className='h-full flex items-center'>
      {width! >= parseInt(TailwindConfig.breakpoints.tablet.min, 10) ? (
        <a href={homeLink} target='_blank'>
          <Image
            src={SedomBrand}
            alt='Sedomicilier Logo'
            className='cursor-pointer'
          />
        </a>
      ) : (
        <>
          {path !== flow[0] && (
            <BackButton
              label={t('back')}
              size='small'
              onClick={() => dispatch(previousPage())}
            />
          )}
        </>
      )}
    </div>
  )
}

export default NavBarBrand
